<script>
    import {createEventDispatcher} from "svelte";

    export let value;

    const dispatch = createEventDispatcher();
    let currentType
    $: currentType = $$props['type']

    function onChange(e) {
        let newValue = e.target.value
        if (currentType === "number") {
            newValue = Number(newValue.replace(",", "."))
            if (newValue === value) return;
            newValue = newValue || 0;
        } else if (currentType === "checkbox") {
            newValue = e.target.checked;
        }

        dispatch('change', {
            data: newValue,
        });
    }
</script>

<input {...$$props} value={value} on:input={onChange}>
